module.exports = __webpack_public_path__ + "img/lightbulb.3f50899a.svg";